module.exports = __webpack_public_path__ + "img/85Cafe.cbb156b9.svg";